import { SxProps, Theme } from "@mui/material";

export const containerStyles = (theme: Theme): SxProps<Theme> => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  mb: 1,
  gap: 2,
  [theme.breakpoints.down("md")]: {
    mb: 0.5,
    gap: 1,
  },
});

export const reactionBoxStyles = (theme: Theme): SxProps<Theme> => ({
  display: "flex",
  gap: 2,
  px: "16px",
  py: "8px",
  borderRadius: "999px",
  backgroundColor: theme.palette.messageMenuDropdown.bg,
  [theme.breakpoints.down("md")]: {
    gap: 1,
    px: "10px",
    py: "5px",
  },
});

export const reactionIconStyles = (theme: Theme): SxProps<Theme> => ({
  fontSize: "1.25rem",
  cursor: "pointer",
  transition: "transform 0.2s ease-in-out",
  "&:hover": { transform: "scale(1.1)" },
  [theme.breakpoints.down("md")]: {
    fontSize: "1.05rem",
  },
});
